import { css } from 'lit';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TextEvent } from 'cra-web-components/components/form-base/cra-form-controller';
import CSSReset from '../css/lib/reset.scss';
import remEventFormStyles from '../rem/rem-event-form-styles';

export const CRA_PASSWORD_VISIBILITY = 'cra:password:visibility';

@customElement('password-input')
export default class PasswordInput extends LitElement {
	@property({ type: Boolean, reflect: true }) isPasswordShown = false;

	@property() name = '';

	@property() value = '';

	@property({ type: Boolean }) isError = false;

	@property() errorMessage = '';

	public static override get styles() {
		return [
			CSSReset,
			remEventFormStyles,
			css`
				:host {
					position: relative;
					display: flex;
					flex-direction: column;
				}
				.password-icon-button {
					all: unset;
					padding: 6px calc(var(--ggutter) / 2);
					right: 0;
					position: absolute;
					cursor: pointer;
				}
				.password-icon {
					width: var(--font-size);
					height: var(--font-size);
					fill: var(--brand-grey-dim);
				}
			`,
		];
	}

	public override render() {
		return html`
			<button
				@click=${this.handlePasswordVisibilityChanged}
				title=${this.isPasswordShown ? 'Hide password' : 'Show password'}
				class="password-icon-button"
			>
				<img
					src="/img/icon-eye-hide.svg"
					class="password-icon"
					alt="Hide password icon"
					?hidden=${!this.isPasswordShown}
				/>
				<img
					src="/img/icon-eye-show.svg"
					class="password-icon"
					?hidden=${this.isPasswordShown}
					alt="Show password icon"
				/>
			</button>
			<input
				name=${this.name}
				.value=${this.value}
				@input=${this.handleInputEvent}
				@blur=${this.handleBlurEvent}
				type=${this.isPasswordShown ? 'text' : 'password'}
				class="field-box"
			/>
			${this.isError ? html`<p class="field-error-msg">${this.errorMessage}</p>` : undefined}
		`;
	}

	handlePasswordVisibilityChanged() {
		this.isPasswordShown = !this.isPasswordShown;
		const customEvent: CustomEvent<boolean> = new CustomEvent(CRA_PASSWORD_VISIBILITY, {
			detail: this.isPasswordShown,
			composed: true,
		});
		this.dispatchEvent(customEvent);
	}

	handleInputEvent(event: Event) {
		const input = event.target as HTMLInputElement;
		this.value = input.value;
		const customEvent: CustomEvent<TextEvent> = new CustomEvent('input', {
			detail: {
				name: this.name,
				value: input.value,
			},
			composed: true,
		});
		this.dispatchEvent(customEvent);
	}

	handleBlurEvent(event: Event) {
		const input = event.target as HTMLInputElement;
		this.value = input.value;
		const customEvent: CustomEvent<TextEvent> = new CustomEvent('blur', {
			detail: {
				name: this.name,
				value: input.value,
			},
			composed: true,
		});
		this.dispatchEvent(customEvent);
	}
}
